<template>
  <div class="page_bg" style="margin:0;">
    <!-- 顶部返回 -->
    <div class="tagIdProList_top ">
      <div class="flex-r-sb-c">
        <div class="flex-r-s-c" style="margin-left: 0.4rem;">
          <van-icon name="arrow-left" size="0.5rem" style="font-weight: 700;margin-top: 0.1rem;" @click="backPath" />
          <div class="top_name" style="font-size: 0.48rem;font-weight: 700;">可用商品</div>
        </div>
        <div class="top_icon" style="margin-right: 0.4rem;" @click="$router.push('/cart/cart')">
          <van-badge :content="$store.getters.totalShopping">
            <div style="height: 0.7rem;line-height: 0.7rem;">
              <van-icon name="shopping-cart-o" size="0.6rem" />
            </div>
          </van-badge>
        </div>
      </div>
      <div class="tagIdProList_ser  flex-c-s-c" style="margin-left: 0.27rem;">
        <div class="ser_search  flex-r-sb-c">
          <van-search v-model="searchValue" class="classify_ser" placeholder="请输入商品名称" shape="round" @search="inputSer"
                      @focus="onFocus"
          />
        </div>
      </div>
      <div style="position: relative;">
        <!-- 顶部过滤 -->
        <serTopFilter ref="serTopFilter" :type="3" :is-coupon="true" :coupon-type-id="$route.query.couponTypeId"
                      :coupon="true" @changeFilter="changeFilter" @changeFiltercategory="changeFiltercategory"
                      @changeFilterbrand="changeFilterbrand"
        />
        <!-- 商品列表区域  -->
        <div class="pro_list" style="margin-top: -0.1rem;background-color: rgb(246, 246, 246);">
          <MyscrollList ref="myList01" :line-type="1" :loading="listLoading" :list="proList" @myload="proload">
            <template #default="slotProps">
              <div class="c_pro_list flex-r-s-s" @click="jumpDetail(slotProps.item)">
                <div class="pro_pic">
                  <van-image :src="slotProps.item.iconUrl" width="2.56rem" height="2.56rem" />
                </div>
                <div class="pro_info">
                  <div class="info_name van-multi-ellipsis--l2">
                    <van-image v-if="slotProps.item.isStrict" width="1.12rem" height="0.43rem"
                               src="https://hxxxkj-oss-cdn.xiaoyi120.com/sysx-xcx/product/tag_yanxuan2.png"
                    />
                    {{ slotProps.item.name }}
                  </div>
                  <div class="info_brand_model van-ellipsis">{{ slotProps.item.brand }} |
                    {{ slotProps.item.specifications }}</div>
                  <div v-if="slotProps.item.releaseFlag === 3" class="presell_pro flex-c-c-c"
                       style="width: 4.37rem;height: 0.43rem;"
                  >
                    <van-image width="100%" height="0.43rem" style="border-radius: 0;"
                               src="https://hxxxkj-oss-cdn.xiaoyi120.com/sysx-xcx/product/tag_yusou.png"
                    />
                  </div>
                  <div class="info_price_add flex-r-sb-c">
                    <div class="info_price"><span>￥</span>{{ slotProps.item.price }}</div>
                    <div class="add_cart" @click="toCart(slotProps.item)">
                      <van-icon name="cart" size="0.53rem" color="#1084D1" />
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </MyscrollList>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import './tagIdProList.scss'
import { couponProductList } from '@/api/user'
import MyscrollList from '@/components/MyscrollList'
// import proCard01 from '@/components/pro_card_01_spu'
import serTopFilter from '@/components/ser_top_filter'
import { shoppingCart_addUnion } from '@/api/cart'
export default {
  components: { MyscrollList, serTopFilter },
  data() {
    return {
      imgs: '',
      searchValue: '',
      name: '',
      // 商品列表
      proSearch: { page: 1, limit: 10, name: '', couponTypeId: '' },
      proList: [],
      listLoading: false
    }
  },
  created() {
    this.proSearch.couponTypeId = this.$route.query.couponTypeId
    this.getProList()
  },
  methods: {
    backPath() { window.history.back() },
    // 商品列表
    getProList() {
      this.$toast.loading({ message: '加载中...', forbidClick: true, loadingType: 'spinner', duration: 0 })
      couponProductList(this.proSearch).then(res => {
        this.$toast.clear()
        this.$refs.myList01.load_loading(false)
        this.proList = this.proList.concat(res.data.list)
        if (parseInt(res.data.list) === 0) { this.$refs.myList01.load_empty('list', true) } else {
          if (res.data.list.length === 0) { this.$refs.myList01.load_finished(true) } // 数据全部加载完成
        }
      })
    },
    proload() {
      this.$refs.myList01.load_loading(true)
      this.$utils.debounce(() => {
        this.proSearch.page = this.proSearch.page + 1
        this.getProList()
        // 加载状态结束
      }, 50)()
    },

    // 顶部搜索
    changeFilter(e) {
      console.log(e)
      this.proSearch.page = 1
      if (e === 1 || e === 41) {
        this.proSearch.orderType = ''
        this.proSearch.orderWay = ''
        this.proSearch.tagId = this.$route.query.tagId; this.proSearch.brand = ''; this.proSearch.categoryId = ''
      }
      if (e === 2) {
        this.issaleNum = !this.issaleNum
        this.proSearch.orderType = 'SALE_NUM'
        this.proSearch.orderWay = this.issaleNum ? 'DESC' : 'ASC'
        this.proSearch.tagId = this.$route.query.tagId; this.proSearch.brand = ''; this.proSearch.categoryId = ''
      }
      if (e === 3) {
        this.isprice = !this.isprice
        this.proSearch.orderType = 'PRICE'
        this.proSearch.orderWay = this.isprice ? 'DESC' : 'ASC'
        this.proSearch.tagId = this.$route.query.tagId; this.proSearch.brand = ''; this.proSearch.categoryId = ''
      }
      this.proList = []
      this.getProList()
    },
    changeFiltercategory(id) {
      this.proSearch.page = 1
      this.proSearch.orderType = ''; this.proSearch.orderWay = ''; this.proSearch.brand = ''
      this.proSearch.tagId = this.$route.query.tagId; this.proSearch.categoryId = id
      this.$nextTick(() => {
        this.proList = []
        this.getProList()
      })
    },
    changeFilterbrand(brand) {
      this.proSearch.page = 1
      this.proSearch.orderType = ''; this.proSearch.orderWay = ''; this.proSearch.brand = brand
      this.proSearch.tagId = this.$route.query.tagId; this.proSearch.categoryId = ''
      this.$nextTick(() => {
        this.proList = []
        this.getProList()
      })
    },
    // 获焦事件
    onFocus() {
      // this.$refs.serTopFilter.closePullBox()
      // this.$refs.myList01.load_status_clear()
      // this.searchValue = ''
      // this.proList = []
      // this.proSearch.page = 1
    },
    inputSer() {
      this.$refs.serTopFilter.closePullBox()
      this.proList = []
      this.proSearch.page = 1
      this.proSearch.name = this.searchValue
      this.getProList()
    },
    // 加入购物车
    toCart(item) {
      const parms = { productId: item.productId, priceNum: item.minQuantity }
      console.log(parms)
      shoppingCart_addUnion(parms).then(res => {
        this.$toast({ message: '加入成功！', duration: 1 * 1000 })
        this.$utils.cartNum(this.$store)
      })
    },
    // 进入详情
    jumpDetail(item) {
      this.$router.push('/product/detail?productId=' + item.productId)
    }
  }
}
</script>

<style>
</style>
